import { useEffect, useState } from "react";

export function useConnectivityListener(onChange?: (online: boolean) => void) {
  const [isOnline, setIsOnline] = useState<boolean>(() =>
    typeof navigator === "undefined" ? true : navigator.onLine
  );

  useEffect(() => {
    const handleChange = () => {
      const nextStatus = navigator.onLine;
      setIsOnline(nextStatus);
      onChange?.(nextStatus);
    };

    window.addEventListener("online", handleChange);
    window.addEventListener("offline", handleChange);

    return () => {
      window.removeEventListener("online", handleChange);
      window.removeEventListener("offline", handleChange);
    };
  }, [onChange]);

  return isOnline;
}
